import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MsalBroadcastService } from "@azure/msal-angular";
import { InteractionStatus } from "@azure/msal-browser";
import { filter, Observable, switchMap, take } from "rxjs";

/**
 * Interceptor that ensures MSAL has completed any authentication interactions
 * before allowing HTTP requests to proceed. This prevents the
 * "interaction_in_progress" error that occurs when components make HTTP requests
 * immediately after login while MSAL is still completing its redirect flow.
 *
 */
@Injectable()
export class MsalReadyInterceptor implements HttpInterceptor {
  public constructor(private readonly msalBroadcast: MsalBroadcastService) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Wait for MSAL to complete any ongoing interactions before proceeding
    return this.msalBroadcast.inProgress$.pipe(
      filter((status) => status === InteractionStatus.None),
      take(1),
      switchMap(() => next.handle(request)),
    );
  }
}
